import { Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  constructor(private reCaptchaV3Service: ReCaptchaV3Service) { }

  async execute(action?: string) {
    return new Promise<string>(resolve => {
      if (!environment.google.recaptcha.enabled) { resolve(undefined); } else { this.reCaptchaV3Service.execute(environment.google.recaptcha.key, action,
        token => resolve(token), { useGlobalDomain: false });
      }
    });
  }

  async header(action?: string): Promise<RecaptchaHeader> {
    return <RecaptchaHeader>{
      'x-recaptcha': JSON.stringify({
        action,
        key: environment.google.recaptcha.key,
        token: await this.execute(action)
      })
    };
  }
}

export class RecaptchaHeader extends HttpHeaders {
  'x-recaptcha': string;
}
